import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, HostListener, Input, inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { ShowPartialJobDetailsFieldsPipe } from '../../../Common/pipes/show-partial-job-details-fields.pipe';
import { CopyToClipboardDirective } from '../../../Common/Directives/copy-to-clipboard.directive';
import { ShieldClicksDirective } from '../../../Common/Directives/shield-clicks.directive';
import { HtmlencodePipe } from 'app/Modules/Common/pipes/htmlencode.pipe';
import { JobsidepreviewService } from '../../Services/jobsidepreview.service';
import { ShowJobDetailsFieldsPipe } from 'app/Modules/Common/pipes/show-job-details-fields.pipe';
import { JobToJobListComponent } from '../job-to-joblist-widget/job-to-joblist-widget.component';
import { SuccessMessageDirective } from '../../../Common/Directives/success-message.directive';
import { JobDetails,JobDetailQuestions,PageLoadJobDetailsResponse,} from '../../Models/jobdetails.model';
import { TgSettingsService } from 'app/services/TG-Setting_Services/tg-settings.service';
import { WebTrackerService } from 'app/services/WebTracker.Service';
import { WebTrackerRequest,WebTrackerResponse,CustomWebTrackerResponse,CustomWebTrackerResponses,PageType,WebTrackingVendor,} from '../../../Common/Models/WebTracker.model';
import { PartialApplyComponent } from '../partial-apply/partial-apply.component';
import { ClickToToggleDirective } from "app/Modules/Common/Directives/click-to-toggle.directive";
import { JobNavigationComponent } from "../job-navigation/job-navigation.component";
import { GenerateAndDisplayMediaTagsPipe } from 'app/Modules/Common/pipes/generate-and-display-media-tags.pipe';
import { SafeHtmlPipe } from 'app/Modules/Common/pipes/safe-html.pipe';
import { ResumeConsentService } from 'app/Modules/Profile/Services/resume-consent.service';
import { ResumeConsentWorkflowService, ResumeWorkflowResult } from 'app/Modules/Profile/Services/resume-consent-workflow.service';

declare var $: any;
declare var IN: any;
declare var FB: any;
declare var twttr: any;

// declare global {
//   interface Window {
//     appScope: any;
//   }
// }

@Component({
  selector: 'app-job-details',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    CopyToClipboardDirective,
    ShowJobDetailsFieldsPipe,
    JobToJobListComponent,
    SuccessMessageDirective,
    PartialApplyComponent,
    JobNavigationComponent,
    GenerateAndDisplayMediaTagsPipe,
    HtmlencodePipe,
    ShieldClicksDirective
   
    
    
],
  templateUrl: './job-details.component.html',
  styleUrl: './job-details.component.scss',
})
export class JobDetailsComponent implements OnInit, OnDestroy {
  public bRenderFacetFilterAccordion = false;
  public bShowFilterAccordion = false;
  public bShowFacetAccordionOptions = false;
  public bFilterAccordionOpen = false;
  public bPinFacetArrow = false;

  bJobDetailsShown: boolean = false;
  bSignInView: boolean = false;
  login: any = {};
  LoginChangeSecQuestion: boolean = false;
  bCreateAccount: boolean = false;
  bPrivacyPages: boolean = false;
  bMultiplePrivacyPages: boolean = false;
  bJobDetailsAPIError: boolean = false;
  tgSettings: any = {};

  Applied: boolean = false;
  ApplyDifference: number = 0;
  bJDScroll: boolean = false;
  bresponsiveCandidateZone: boolean = false;
  isNonProfileAllowed: boolean = false;
  bCandidateZone: boolean = false;
  DashboardPrevPage: any[] = [];
  LimitExceededMessage: string = '';
  prevJob: any = null;
  nextJob: any = null;
  enableSocialReferral: boolean = false;
  jobDetailFields: any;
  isHotJob: boolean = false;
  dropdownVisible: boolean = false;
  isPlaying: boolean = false;
  bConfigMode: boolean = false;
  viewSimilarJobsBtn: boolean = false;
  private snackBar = inject(MatSnackBar);
  private pausedChunkIndex: number = 0;
  workFlow: string = '';
  jobDetails!: JobDetails;
  jobDetailsAPIError: boolean = false;
  dynamicStrings: any;
  encryptedBruid: string = '';
  partialApplyQuestions: string = '';
  childApiKey: any;
  disableJobCart: boolean = false;
  jobDetailsButtonText: any;
  ShowSimilarJobs: boolean = false;
  enableJobDetailsSendToFriend: boolean = false;
  jobDetailQuestions: JobDetailQuestions[] = [];
  ErrorMessageJobTitle: any;
  solarErrorOccurred: any;
  bJobSaved: boolean = false;
  bJobShareCopied: boolean = false;
  ShowJobAlert: boolean = false;
  bBypassGQLogin: boolean = false;
  bLoggedIn: boolean = false;
  AnonymousLoginType: any;
  EnableJobMapviewClientSetting: any;
  smartSearchRequest: any;
  previousHashes: any;
  previousHashesWithJobKeys: any;
  hTrackJDScrl: any;
  response: PageLoadJobDetailsResponse | null = null;
  bShowBackButton: boolean = false;
  bHideBackButtonInJobDetails: boolean = false;
  navigationParams: any;
  ByPassGQLogin: any;
  launchRecommendedJobsWidget:boolean = false;
  LinkedInSettings: any;
  enableLinkedInButton: boolean = false;
  applyWithLinkedInButtonColor: any;
  buttonColor: any;
  jobs: any[] = [];
  showSocialReferralSection: boolean = false;
  hasRequiredEducation: boolean = false;
  hasQualifiedExperience: boolean = false;
  hasProfessionalCertification: boolean = false;
  ClientSettings: any;
  ngDialog: any;
  enablePostToMySocialNetwork: any = false;
  noSwitchSiteWarning: any = false;
  jobDetailsUrlForSocialMedia: string = '';
  bSearchResults: any;
  showPolicySwitchSite: string = '';
  jobDetailsJobShown: any;
  AllowReApply: any;
  jobDetailsFieldsToDisplay: any;
  hashCode: any;
  SkillsFields: any;
  selectedJobTitle: string = '';
  mobileScreen: boolean = false;
  tgChatBot: any;
  pageURL: string = '';
  bSidebarVisible: boolean = false;
  bNewSearchResultPage: boolean = false;
  searchResultsURL: any;
  parentJobDetailsScope: any;
  bInitialLoad: any;
  bJobDetailsNextToSearchResultsShown: any;
  jobSiteInfo: any;
  appScope: any;
  GeneralJobSubmissionWorkflow: boolean = false;
  SearchURL: any;
  JobDetailsHash: any;
  job: any;
  url: any;
  JobDetailQuestionsSocialShare: any;
  customScriptRendering: any;
  PartialApplyRequestInput: any;
  @ViewChild(PartialApplyComponent) partialApplyRef?: PartialApplyComponent;
  webtrackerRequest: any;
  jobTitleInterval: any;
  linkedInbuttonColor: any;
  linkedInProfileImported: any;
  elements: any;
  bHideMainJobList: boolean = false;
  showJobdetailsPage:boolean=false;
  jobtojobListInputParams : any;
  jobDetailsInputParams : any;
  bFromHistory : any;
  calledFrom: string = '';
  jobApplyUrl: string = '';
  jobIds: string = '';
  jobInfo: string = '';
  backtobSignInView: boolean = false;
  showInFullView: boolean = false;
  sendToFriendInfo: any = {};
  AppliedJobsList: any;
  appliedList: any;
  AppliedToJob: any;
  NewSessionID: any;
  partnerid :any;
  siteid:any;
  viewRelaventjobsJobsBtn : boolean = false;
  bPowerSearchVisible : boolean = false;
  blockApplyButton:boolean = false;

  enumForDashBoardActiveSection: any = {
    FinishedApplications: 0,
    ActiveApplications: 1,
    AllApplications: 2,
  };

  constructor(
    private translate: TranslateService,
    private jobsidepreviewservice: JobsidepreviewService,
    private http: HttpClient,
    private tgSettingsService: TgSettingsService,
    private webTrackerService: WebTrackerService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private resumeConsentService: ResumeConsentService,
    private resumeConsentWorkflowService: ResumeConsentWorkflowService,
    private cdr: ChangeDetectorRef,
  ) {}

 @Input() set JobdetailsData(value: any) {
  if (!value) return;
  console.log('Data Input Received', value);
  this.jobDetailsInputParams = value;

  // With Angular Elements the property can be set AFTER ngOnInit has already run
  // (e.g. search.js sets it post-connect). ngOnInit only loads when the value was
  // buffered before connect, so trigger the load here for the post-connect case.
  if (this.viewInitialized) {
    this.loadFromInputParams();
  }
}

private viewInitialized = false;
private jobDetailsLoaded = false;

private loadFromInputParams(): void {
  const p = this.jobDetailsInputParams;
  if (!p || p.url == null || this.jobDetailsLoaded) return;
  this.jobDetailsLoaded = true;
  this.jobTitle(p.url, p.jobdetailrequestdata, p.launchJobDetailsOnLoad, p.currentElem_id, p.jobs);
}



  ngOnInit(): void {
    this.tgSettings = this.tgSettingsService.getCurrentSettings()?.tgSettings;
    this.enableSocialReferral = this.tgSettings?.['EnableSocialReferral'];

    this.customScriptRendering = {
      All: 1,
      Search: 2,
      CandidateZone: 3,
    };

    this.mobileScreen = $(window).width() <= 768;
    this.viewInitialized = true;

    if (this.jobDetailsInputParams && this.jobDetailsInputParams.url != null) {
      this.loadFromInputParams();
    }
    this.AnonymousLoginType = this.jobDetailsInputParams?.scope?.anonymousLoginType;
    this.showJobdetailsPage = true;
    this.LoadApplyWithLinkedInButtonColor();

    if (!this.jobDetailsInputParams && isPlatformBrowser(this.platformId)) {
      const hash = window.location.hash;
      if (hash.startsWith('#jobDetails=')) {
        const hashData = hash.replace('#jobDetails=', '');
        const [jobId, jobSiteId] = hashData.split('_');
        if (jobId) {
          const req = {
            partnerId: this.partnerid,
            siteId: this.siteid,
            jobid: jobId,
            configMode: ($('#configMode').val() as string),
            jobSiteId: jobSiteId || '',
            turnOffHttps: false,
          };
          this.jobTitle('/TgNewUI/Search/Ajax/JobDetails', req, false, jobId, []);
        }
      }
    }
    if (this.tgSettings?.['blockApplyButton'] == 'true') {
      this.blockApplyButton = true;
    }
  }

  @HostListener('window:triggerJobDetailsTitle', ['$event'])
  onTriggerJobDetailsTitle(event: any) {
    if (!event?.detail) return;
    const appScope = (window as any).appScope;
    const job = appScope?.job;
    if (!job) return;

    const jobId = job.Questions?.find((q: any) => q.QuestionName === 'reqid')?.Value || '';
    const jobSiteId = job.Questions?.find((q: any) => q.QuestionName === 'siteid')?.Value || '';

    const jobDetailsRequest = {
      partnerId: this.partnerid,
      siteId: this.siteid,
      jobid: jobId,
      configMode: $('#configMode').val(),
      jobSiteId: jobSiteId,
      turnOffHttps: false,
    };

    this.jobTitle('/TgNewUI/Search/Ajax/JobDetails', jobDetailsRequest, false, event.detail.jobId, appScope?.jobs ?? []);
  }
  @HostListener('window:hashchange', ['$event'])
  onHashChange(event: HashChangeEvent): void {
    // event.newURL can be absent in some browser/programmatic navigation paths;
    // window.location is always authoritative after hashchange fires.
    const newHash = window.location.hash.replace('#', '');
    if (!newHash.startsWith('jobDetails')) {
          this.bJobDetailsShown = false;
          this.showJobdetailsPage = false;
          this.bJobDetailsNextToSearchResultsShown = false;
    } else {
      // Navigating back TO a #jobDetails= hash
      if (this.jobDetailFields) {
        // Cached data still in memory — restore visibility without an extra API call
        const isSidebarMode =
          this.tgSettings?.['DisplayJobDetailsNextToSearchResults']?.toLowerCase() === 'yes' &&
          !this.mobileScreen;
        if (isSidebarMode) {
          this.bJobDetailsNextToSearchResultsShown = true;
        } else {
          this.bJobDetailsShown = true;
        }
        this.showJobdetailsPage = true;
      } else {
        // No cached data (e.g. direct URL entry then back) — reload from hash
        const hashData = newHash.replace('jobDetails=', '');
        const [jobId, jobSiteId] = hashData.split('_');
        if (jobId) {
          const req = {
            partnerId: ($('#partnerId').val() as string),
            siteId: ($('#siteId').val() as string),
            jobid: jobId,
            configMode: ($('#configMode').val() as string),
            jobSiteId: jobSiteId || '',
            turnOffHttps: false,
          };
          this.jobTitle('/TgNewUI/Search/Ajax/JobDetails', req, false, jobId, []);
        }
      }
    }
  }

  @HostListener('window:triggerApplyFromDetail', ['$event'])
  onTriggerApply(event: any): void {
    this.postToNextPageFromDetails(event, this, 'apply');
  }

  @HostListener('window:loginInJobDetailsPage', ['$event'])
  onJobSelected(event: any): void {
    const { data } = event.detail ?? {};

    this.bLoggedIn = true;
    this.bSignInView = false;
    this.showInFullView = false;
    this.backtobSignInView = false;
    this.login.ForgotPass = false;
    this.bCreateAccount = false;
    this.bPrivacyPages = false;
    this.bMultiplePrivacyPages = false;
    this.Applied = data?.ApplyStatus?.[0]?.Applied;
    this.ApplyDifference = (data?.ApplyStatus?.[0]?.ApplyDifference == null ||data?.ApplyStatus?.[0]?.ApplyDifference == 0 )? this.ApplyDifference : data?.ApplyStatus?.[0]?.ApplyDifference;
    this.AppliedJobsList = data?.ApplyStatus?.[0]?.AppliedJobsList;
    this.appliedList = data?.appliedList;
    this.AppliedToJob = data?.AppliedToJob;
    this.jobDetailsInputParams.currentJob = data?.jobDetails;
    this.jobDetailsInputParams.jobdetailrequestdata = data?.jobDetailsRequestData;
    this.encryptedBruid = data?.EncryptedBruId;
    this.NewSessionID = data?.NewSessionID;

    (window as any).appScope?.checkAndLaunchResumeWorkflow?.();
  }

  ngAfterViewInit(): void {
    document.title="Job Detail Page";
    this.tgChatBot = (window as any).appScope?.tgChatBot;
    this.InitialiseJobdetails(true);
    this.loadLinkedInScript();
    this.pageURL = window.location.href;
    this.JobDetailsHash = window.location.hash;
    this.bresponsiveCandidateZone=this.tgSettings?.['ResponsiveCandidateZone'];
    // this.bCandidateZone =  this.job?.scope?.bCandidateZone;
    // this.bSearchResults = this.job?.scope?.bSearchResults;

    this.bHideBackButtonInJobDetails =
      $('#hideBackButtonOnly').val() == '1' ? true : false;
//      this.bHideBackButtonInJobDetails = this.appScope.bHideBackButtonInJobDetails;

    this.bLoggedIn = (window as any).appScope?.bLoggedIn;

     
    this.bShowBackButton = $("#noback").val() == "0" ? false : true;    
  }

  CloseJobsSavedAlert(flag: boolean) {
    this.bJobSaved = false;
  }

  CloseHeaderStickerAlert(property: string) {
    if (property === 'bJobShareCopied') {
      this.bJobShareCopied = false;
    }
    this.bConfigMode = !!($("#configMode").attr("value") == "1");
  }

  loadLinkedInScript() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if (typeof document !== 'undefined') {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://platform.linkedin.com/xdoor/scripts/in.js';

      // Use a slight delay to ensure response data is available if needed,
      // or just rely on the template variables if they are already mapped.
      console.log('childapikey', this.tgSettings?.['childapikey']);
      let apiKey =
        this.response?.ClientSettings?.find((x) => x?.key === 'ChildApiKey')
          ?.value || '';
      if (apiKey == 'undefined') {
        apiKey = this.tgSettings?.['childapikey'];
      }

      script.text = `
            api_key: ${apiKey}
            extensions: AwliWidget@https://www.linkedin.com/talentwidgets/extensions/apply-with-linkedin-widget-v3
        `;
      document.head.appendChild(script);
    }
  }

  ngOnDestroy(): void {
    if (typeof window !== 'undefined' && window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
    if (this.jobTitleInterval) {
      clearInterval(this.jobTitleInterval);
    }
    }

  clipAccordionHeight() {
    var bClip, $accordion, y;

    if (this.bShowFilterAccordion) {
      $accordion = this.bShowFacetAccordionOptions
        ? this.elements.facetFilterAccordionOptions
        : this.elements.facetFilterAccordionCategories;
      y = $accordion.offset().top + $accordion.height();
      bClip = y > $(window).height();
    }

    if (bClip) {
      this.bHideMainJobList = true;
      this.bPinFacetArrow = true;
    } else {
      this.bHideMainJobList = false;
      this.bPinFacetArrow = false;
    }

    // setTimeout(function () { $scope.$apply(); });
  }
  JobdetailSocialShare() {
    if (this.tgSettings['ShowSocMediaButtonsOnJobDetailsPage'] == 'yes') {
      if (this.tgSettings['SocialMedia'].split(',').indexOf('1') > -1) {
        if (typeof IN != 'undefined') {
          $('.linkedin').html(
            "<script type='IN/Share' data-counter='right' data-url=\"" +
              this.jobDetailsUrlForSocialMedia +
              '"></script>',
          );
          IN.parse();
        } else {
          if ($('#pageURL').val().indexOf('https://') > -1) {
            $.getScript('https://platform.linkedin.com/in.js', () => {
              $('.linkedin').html(
                "<script type=IN/Share data-counter='right' data-url=\"" +
                  this.jobDetailsUrlForSocialMedia +
                  '"></script>',
              );
            });
          } else {
            $.getScript('http://platform.linkedin.com/in.js', () => {
              $('.linkedin').html(
                "<script type=IN/Share data-counter='right' data-url=\"" +
                  this.jobDetailsUrlForSocialMedia +
                  '"></script>',
              );
            });
          }
        }
      }
      if (this.tgSettings['SocialMedia'].split(',').indexOf('2') > -1) {
        if (
          typeof $.queryParams()['FBShare'] == 'undefined' &&
          (navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > -1)
        ) {
          /* Microsoft Internet Explorer detected in. */
        } else {
          if (typeof FB != 'undefined') {
            $('.facebook').html(
              '<fb:share-button href="' +
                this.jobDetailsUrlForSocialMedia +
                "\" send='false' layout='button_count' show_faces='false' font=''></fb:share-button>",
            );
            FB.getLoginStatus((response: any) => {
              $('#fb-root')
                .attr('role', 'region')
                .attr('aria-label', 'Facebook Share');
            });
            FB.init({
              status: true,
              cookie: true,
              xfbml: true,
              version: 'v3.0',
            });
          } else {
            if ($('#pageURL').val().indexOf('https://') > -1) {
              $.getScript('https://connect.facebook.net/en_US/sdk.js', () => {
                $('.facebook').html(
                  '<fb:share-button href="' +
                    this.jobDetailsUrlForSocialMedia +
                    "\" send='false' layout='button_count' show_faces='false' font=''></fb:share-button>",
                );
                FB.getLoginStatus((response: any) => {
                  $('#fb-root')
                    .attr('role', 'region')
                    .attr('aria-label', 'Facebook Share');
                });
                FB.init({
                  status: true,
                  cookie: true,
                  xfbml: true,
                  version: 'v3.0',
                });
              });
            } else {
              $.getScript('http://connect.facebook.net/en_US/sdk.js', () => {
                $('.facebook').html(
                  '<fb:share-button href="' +
                    this.jobDetailsUrlForSocialMedia +
                    "\" send='false' layout='button_count' show_faces='false' font=''></fb:share-button>",
                );
                FB.getLoginStatus((response: any) => {
                  $('#fb-root')
                    .attr('role', 'region')
                    .attr('aria-label', 'Facebook Share');
                });
                FB.init({
                  status: true,
                  cookie: true,
                  xfbml: true,
                  version: 'v3.0',
                });
              });
            }
          }
        }
      }
      if (this.tgSettings['SocialMedia'].split(',').indexOf('3') > -1) {
        if (
          navigator.userAgent.indexOf('MSIE') !== -1 ||
          navigator.appVersion.indexOf('Trident/') > -1
        ) {
          /* Microsoft Internet Explorer detected in. */
        } else if (typeof twttr != 'undefined') {
          $('.Twitter').html(
            "<a href='https://twitter.com/share' class='twitter-share-button' data-url=\"" +
              $('#pageURL').val() +
              '/tgwebhost/jobdetails.aspx?jobid=' +
              _.map(
                _.filter(this.JobDetailQuestionsSocialShare, {
                  VerityZone: 'reqid',
                }),
                'AnswerValue',
              ).toString() +
              '&partnerid=' +
              $('#partnerId').val() +
              '&siteid=' +
              $('#siteId').val() +
              '&type=mail' +
              '" data-count=\'horizontal\' data-lang="' +
              this.tgSettings['DefLocaleId'] +
              '">Tweet</a>',
          );
          twttr.widgets.load();
        } else {
          $('.Twitter').html(
            "<a href='https://twitter.com/share' class='twitter-share-button' data-url=\"" +
              $('#pageURL').val() +
              '/tgwebhost/jobdetails.aspx?jobid=' +
              _.map(
                _.filter(this.JobDetailQuestionsSocialShare, {
                  VerityZone: 'reqid',
                }),
                'AnswerValue',
              ).toString() +
              '&partnerid=' +
              $('#partnerId').val() +
              '&siteid=' +
              $('#siteId').val() +
              '&type=mail' +
              '" data-count=\'horizontal\' data-lang="' +
              this.tgSettings['DefLocaleId'] +
              "\">Tweet</a><script type='text/javascript' src='https://platform.twitter.com/widgets.js'></script>",
          );
        }
      }
    }
  }
  jobDetailsBackToSaveDrafts() {
    document.location.href = '/tgwebhost/aip.aspx?sid=' + $('#SIDValue').val();
  }
  LoadApplyWithLinkedInButtonColor() {
    this.linkedInbuttonColor =
      typeof (window as any).tgTheme?.isNegativeColorScheme != 'undefined' &&
      (window as any).tgTheme?.isNegativeColorScheme
        ? 'white'
        : 'blue';
    this.linkedInProfileImported = false;
  }

  postToNextPageFromDetails(event: any, scope: any, calledFrom: string, checkDraft?: any): void {
    if (this.showVBTWarningAlert()) return;

    const appScope = (window as any).appScope;
    appScope.ApplyFromSimilarJobs = false;
    appScope.ContinueViaPartialApply = false;

    this.calledFrom = calledFrom;
    this.backtobSignInView = false;

    const Questions: any[] = this.jobDetailFields?.JobDetailQuestions ?? [];
    const isGQResponsive: boolean = this.jobDetailFields?.isGQResponsive ?? false;

    const jobId: string = _.map(_.filter(Questions, { VerityZone: 'reqid' }), 'AnswerValue').toString();
    const gqId: string = _.map(_.filter(Questions, { VerityZone: 'gqid' }), 'AnswerValue').toString();
    const langId: string = _.map(_.filter(Questions, { VerityZone: 'jobreqlanguage' }), 'AnswerValue').toString();
    var localeId: string = this.jobDetailFields?.localeId ?? '';
    const siteId: string = _.map(_.filter(Questions, { VerityZone: 'siteid' }), 'AnswerValue').toString();
    const origSiteId: string = $('#siteId').val();
    const partnerId: string = $('#partnerId').val();
    const encryptedBruid: string = this.encryptedBruid;
    const jobTitle: string = _.map(_.filter(Questions, { VerityZone: 'jobtitle' }), 'AnswerValue').toString();

    const skillFields: string[] = (typeof this.SkillsFields === 'string' && this.SkillsFields)
      ? this.SkillsFields.split(',', 2) : [];

    let req_skills: string = '';
    let rec_skills: string | any[] = '';
    let loc: string = '';

    if (skillFields.length > 0) {
      const reqSkillField = skillFields[0].toLowerCase();
      const recSkillField = skillFields.length > 1 ? skillFields[1].toLowerCase() : '';
      req_skills = _.map(_.filter(Questions, { VerityZone: reqSkillField }), 'AnswerValue').toString();
      rec_skills = recSkillField
        ? _.map(_.filter(Questions, { VerityZone: recSkillField }), 'AnswerValue').toString()
        : [];
      loc = _.map(_.filter(Questions, { VerityZone: 'reqlocation' }), 'AnswerValue').toString();
    }

    const jobsToBeSaved = [{ JobTitle: jobTitle, ReqId: jobId, SiteId: siteId, JobReqLang: langId, LocaleId: localeId }];
    const groupGQId = gqId;
    const jobInfo = `%%${jobId}|${langId}|${gqId}%%`;
    this.jobSiteInfo = `${jobId}_${siteId}`;
    this.jobIds = jobId;
    this.jobInfo = jobInfo;

    var rft: string = $('[name="__RequestVerificationToken"]').val();
    const referButton = $('#SocialReferralButton')[0];

    // Sidebar visibility
    if (this.tgSettings?.['DisplayJobDetailsNextToSearchResults']?.toLowerCase() === 'yes' && !this.mobileScreen) {
      this.bJobDetailsShown = false;
      if (appScope?.oHistory?.['keyWordSearch=&locationSearch=']?.bJobDetailsNextToSearchResultsShown) {
        appScope.oHistory['keyWordSearch=&locationSearch='].bJobDetailsNextToSearchResultsShown = false;
      }
    } else {
      this.bJobDetailsShown = true;
    }

    // ---- Responsive-GQ / modern apply flow ----
    if (calledFrom === 'apply' && ($.queryParams()?.applyTest || isGQResponsive)) {
     
      if (siteId != origSiteId) {
        this.jobApplyUrl = "&tqid=" + gqId + "&reqid=" + jobId + "&partnerid=" + partnerId + "&siteid=" + siteId + "&calledFrom=JobDetails";
      }
      else {
        this.jobApplyUrl = "&tqid=" + gqId + "&localeid=" + localeId + "&reqid=" + jobId + "&partnerid=" + partnerId + "&siteid=" + siteId + "&loadingViaAjax=true";
      }

      appScope.jobApplyUrl = this.jobApplyUrl;

      if (this.bLoggedIn && this.ApplyDifference > 0) {
        if (siteId !== origSiteId) {
          // Cross-site: switch site then navigate to ApplyWithPreLoad
          const switchSiteRequest = {
            PartnerId: partnerId,
            SwitchToSiteId: siteId,
            FromSiteId: origSiteId,
            CookieValue: $('#CookieValue').val(),
          };
          this.http.post<any>('/TgNewUI/Search/Ajax/SwitchSite', switchSiteRequest, { headers: { RFT: rft } }).subscribe({
            next: (data: any) => {
              if (data?.Success === true) {
                const policyParam = data.PendingPolicyAcceptance ? '&showPolicySwitchSite=true' : '';
                const bruid = encryptedBruid || $.queryParams()?.bruid;
                window.location.href = `/TgNewUI/Search/Home/ApplyWithPreLoad?partnerid=${partnerId}&siteid=${siteId}&TQId=${gqId}&bruid=${encodeURIComponent(bruid)}&reqid=${jobId}&calledFrom=JobDetails&srcqs=${appScope?.srcqs ?? ''}${policyParam}`;
              }
            },
            error: (err: any) => console.error('SwitchSite failed during apply', err),
          });
        } else {
          if (this.tgSettings?.['EnablePartialApplyQuestions']?.toLowerCase() == 'yes' && appScope.PartialApplySessionID != "" && calledFrom != 'apply'){
            var params = new URLSearchParams(this.jobApplyUrl);
            localeId = params.get("localeid") || localeId;
            var url = "/GQWeb/ContinueToApplication?partnerid=" + partnerId + "&siteid=" + siteId + "&localeid=" + localeId;
            rft = $("[name='__RequestVerificationToken']").val();
            var requestData = {
                serializedRequest: "",
                session: appScope.PartialApplySessionID,
                TQId: this.jobDetailFields?.tqid
            };

            this.http.post(url, requestData, {
                headers: {
                    'Content-Type': 'application/json',
                    'RFT': rft
                },
                responseType: 'text'
            }).subscribe({
                next: (resultText: string) => {
                    if (this.tgSettings?.['EnablePartialApplyQuestions']?.toLowerCase() == 'yes' && $("#partialApplyDom")?.[0] != undefined)
                        $("#partialApplyDom")[0].innerHTML = "";

                    let result: any = resultText;
                    try {
                        result = JSON.parse(resultText);
                    } catch (e) {
                        // ignore
                    }

                    appScope.$root.workFlow = appScope.workFlow = "apply";
                    appScope.backtobSignInView = false;
                    appScope.bSignInView = false;
                    appScope.showInFullView = false;
                    appScope.$root.applyResponse = result;
                    if (this.tgSettings.DisplayJobDetailsNextToSearchResults != undefined && this.tgSettings.DisplayJobDetailsNextToSearchResults.toLowerCase() == "yes" && !this.mobileScreen)
                    {
                        this.bJobDetailsShown = true;
                    }
                    if (typeof appScope.$apply === 'function') appScope.$apply();
                }
            });
            }
            else
            {
                rft = $("[name='__RequestVerificationToken']").val();
                var src = $("#SrcValue").val();
                this.http.get(
                    "/gqweb/apply?bruid=" + encodeURIComponent(appScope?.encryptedBruid) + "&tqid=" + gqId + "&localeid=" + localeId + "&reqid=" + jobId + "&partnerid=" + partnerId + "&siteid=" + siteId + "&Src=" + src + "&loadingViaAjax=true&RFT=" + rft,
                    { responseType: 'text' }
                ).subscribe({
                    next: (resultText: string) => {
                        if (this.tgSettings?.['EnablePartialApplyQuestions']?.toLowerCase() == 'yes' && $("#partialApplyDom")?.[0] != undefined)
                            $("#partialApplyDom")[0].innerHTML = "";

                        let result: any = resultText;
                        try {
                            result = JSON.parse(resultText);
                        } catch (e) {
                            // ignore
                        }

                        if (result != '')
                        {
                            if (scope?.oActiveLaddaButton)
                                scope.oActiveLaddaButton.stop();
                            appScope.$root.workFlow = appScope.workFlow = this.workFlow = "apply";
                            appScope.$root.applyResponse = result;
                            if (typeof appScope.$apply === 'function') appScope.$apply();
                        }
                        else
                        {
                            if (scope?.oActiveLaddaButton)
                                scope.oActiveLaddaButton.stop();

                            appScope.showSessionExpired();
                        }
                    },
                    error: (err: any) => {
                        if (scope?.oActiveLaddaButton)
                        {
                            scope.oActiveLaddaButton.stop();
                            appScope.showSessionExpired();
                        }
                    }
                });
            }
        }
      } else if (!this.bLoggedIn) {
        if (this.isNonProfileAllowed) {
          this.showPrivacyPolicyForNonLoggedIn('NoLogin');
        } else {
          if (this.tgSettings?.['ByPassGQLogin'] === 'True' && (calledFrom == "apply" || calledFrom == "mulapplyvald")) {
            this.bBypassGQLogin = true;
            appScope.bBypassGQLogin=true;
            this.AnonymousLoginType = '';
          }
          appScope.backtobSignInView = true;
          appScope.bSignInView = true;
          appScope.showInFullView = true;
          $('#hSMLocaleId').val(localeId);
          $('#hSMJobId').val(jobId);
          $('#hSMTQId').val(gqId);
          this.bJobDetailsShown = false;
          this.showJobdetailsPage = false;
          if (typeof appScope.$apply === 'function') appScope.$apply();
          setTimeout(() => window.scrollTo(0, 0), 0);
        }
      } else {
        this.ShowJobAlert = true;
      }
      return;
    }
   

    // Not-logged-in guard for save/refer
    if (!this.bLoggedIn && (calledFrom === 'save' || calledFrom === 'refer')) {
       this.bJobDetailsShown = false;
      appScope.backtobSignInView = true;
      appScope.bSignInView = true;
      appScope.showInFullView = true;
      appScope.calledFrom= this.calledFrom= calledFrom;
      $('#hSMLocaleId').val(localeId);
      $('#hSMJobId').val(jobId);
      $('#hSMTQId').val(gqId);
      if (typeof appScope.$apply === 'function') appScope.$apply();
      setTimeout(() => window.scrollTo(0, 0), 0);
      return;
    }
    if (scope?.oActiveLaddaButton)
      scope.oActiveLaddaButton.start();


    // Persist search criteria in session (fire-and-forget; non-critical)
    const searchCriteria = appScope?.GetSearchCriteria?.() ?? {};
    this.http.post('/TgNewUI/Search/Ajax/SaveSearchCriteriaInSessionXML', searchCriteria, { headers: { RFT: rft } })
      .subscribe({ error: () => {} });

    switch (calledFrom) {
      case 'apply': {
        // Legacy non-responsive GQ path
        const bJobCart: boolean = appScope?.bJobCart ?? false;
        const type = (bJobCart && this.bCandidateZone) ? 'cart_jobdetail' : 'search_jobdetail';
        const maxGqId = Math.max(...groupGQId.split(',').map(Number));

        if (gqId === '0') {
          ($ as any).form(
            `../../../TGwebhost/apply.aspx?SID=${$('#SIDValue').val()}`,
            { JobInfo: jobInfo, ApplyCount: '1', type, JobSiteId: siteId, hdRft: $('#rfToken').val() },
            'POST'
          ).submit();
        } else if (this.tgSettings?.['Mobileoptimised'] === 'true') {
          const gqLoginUrl = `../${localeId}/asp/tg/GQLogin.asp?SID=GQSESSION&fjd=true&referer=&gqid=${maxGqId}&jobinfo=${jobInfo.replace(/%%/g, '__')}&applycount=1&type=${type}&mobile=1`;
          ($ as any).form(
            `../../../TGwebhost/apply.aspx?SID=${$('#SIDValue').val()}`,
            { JobInfo: jobInfo, ApplyCount: '1', type, JobSiteId: siteId, GQLoginURL: gqLoginUrl, hdRft: $('#rfToken').val() },
            'POST'
          ).submit();
        } else {
          if (this.tgSettings?.['Mobileoptimised'] === 'true') {
            const postValues = {
              JobInfo: jobInfo,
              ApplyCount: '1',
              type: type,
              JobSiteId: scope.siteId,
              GQLoginURL: '../' + scope.jobDetailFields.localeId + '/asp/tg/GQLogin.asp?SID=GQSESSION&fjd=true&referer=&gqid=' + _.max(groupGQId.split(',')) + '&jobinfo=' + jobInfo.replace(/%%/g, '__') + '&applycount=1&type=' + type + '&mobile=1',
              hdRft: $('#rfToken').val()
            }; // need to change gqlogin url

            const redirectPage = 'apply.aspx';
            ($ as any).form('../../../TGwebhost/' + redirectPage + '?SID=' + $('#SIDValue').val(), postValues, 'POST').submit();
          } else {
            let isSiteSwitched = false;
            if (siteId != origSiteId) {
              this.switchSite(siteId, 'fromApply');
              isSiteSwitched = true;
            }
            window.open(
              '../../../' + scope.jobDetailFields.localeId + '/asp/tg/GQLogin.asp?SID=' + $('#SIDValue').val() + '&language=' + langId + '&fjd=true&referer=&gqid=' + _.max(groupGQId.split(',')) + '&jobinfo=' + jobInfo.replace(/%%/g, '__') + '&applycount=1&type=' + type,
              '_blank',
              'height=550,width=750,menubar=no,toolbar=no,resizable=yes,scrollbars=yes,alwaysRaised'
            );
            if (isSiteSwitched) {
              window.location.href = '/TgNewUI/Search/Home/HomeWithPreLoad?partnerid=' + $('#partnerId').val() + '&siteid=' + siteId + '&jobid=' + jobId + '&PageType=jobdetails&srcqs=' + (window.appScope && window.appScope.srcqs ? window.appScope.srcqs : '');
            }
          }
        }
        break;
      }

      case 'save':
         this.bJobDetailsShown = false;
        this.saveToJobCartAjax(partnerId, siteId, jobsToBeSaved);
        break;

      case 'email':
        if (!this.bresponsiveCandidateZone) {
          const postValues: any = { JobInfo: jobInfo, JobSiteInfo: this.jobSiteInfo, hdRft: $('#rfToken').val() };
          let redirectPage: string;
          if (this.tgSettings?.['Mobileoptimised'] === 'true') {
            postValues.JobTitle = this.jobDetailFields?.Title;
            redirectPage = 'mobile/sharejob.aspx';
          } else {
            postValues.STFJobTitle = this.jobDetailFields?.Title;
            redirectPage = 'emailtofriend.aspx';
          }
          ($ as any).form(`../../../TGwebhost/${redirectPage}?SID=${$('#SIDValue').val()}`, postValues, 'POST', '_blank').submit();
        } else {
          appScope.jobInfo = jobInfo;
          this.openSendToFriend?.('2', this.jobDetailFields);
        }       
        break;

      case 'refer':
        this.bJobDetailsShown = false;
        if (this.bresponsiveCandidateZone && this.tgSettings?.['EnableResponsiveSocialReferralQuestions'] === 'true') {
          if (appScope?.SocialReferral_READY === 'yes') {
            appScope.SocialReferral_READY = 'no'; // was == (comparison bug) — now correctly resets the guard flag
            appScope?.LaunchSocialReferralMenu?.(this, referButton);
          } else {
            appScope?.renderReferralQuestions?.(langId);
          } 
        } else if (appScope?.SocialReferral_READY === 'yes') {
          setTimeout(() => appScope?.LaunchSocialReferralMenu?.(this, referButton), 0);
        } else {
          ($ as any).form(
            `../../../TGwebhost/socialnetworkreferral.aspx?SID=${$('#SIDValue').val()}`,
            { ButtonId: 'SocialReferralButton', hdRft: $('#rfToken').val() },
            'POST', '_blank'
          ).submit();
        }
        break;

      case 'share':
        ($ as any).form(
          `../../../TGwebhost/socialmedia.aspx?SID=${$('#SIDValue').val()}`,
          { jobid: jobId, hdRft: $('#rfToken').val(), langId, localeId, jobSiteId: siteId },
          'POST', '_blank'
        ).submit();        
        break;

      case 'similar':
        appScope?.searchSimilarJobs?.(jobId, req_skills, rec_skills, loc);
        break;
    }
  }
  showPrivacyPolicyForNonLoggedIn(logintype: any) {
    (window as any).appScope?.showPrivacyPolicyForNonLoggedIn?.(logintype);
    // The AngularJS handler navigates via history.back()/homeView() which changes
    // the URL correctly but never touches Angular state. Reset visibility flags here.
    this.bJobDetailsShown = false;
    this.showJobdetailsPage = false;
    // Partial apply manages its own visibility via its internal bJobDetailsShown flag.
    // Set it directly so the component hides without being destroyed and recreated.
    //if (this.partialApplyRef) this.partialApplyRef.bJobDetailsShown = false;
  }

  toggleFilterFacetAccordion() {
    var $triggerButton = $('a.refine.arrow.mobileOnly');
    $.captureFocus($triggerButton);
    this.bRenderFacetFilterAccordion = true;
    this.bShowFilterAccordion = !this.bShowFilterAccordion;

    var $accordion = this.bShowFacetAccordionOptions
      ? this.elements.facetFilterAccordionOptions.add(
          this.elements.facetFilterAccordionCategories,
        )
      : this.elements.facetFilterAccordionCategories;

    if ($accordion?.slideToggle) {
      $accordion.slideToggle(null, this.clipAccordionHeight);
    }

    if (this.bShowFilterAccordion) {
      setTimeout(() => {
        const $firstItemLink = $accordion?.find('a').first();
        if ($firstItemLink?.length) {
          $firstItemLink.focus();
        }
        $accordion?.trapFocus();
      }, 150);
    } else {
      setTimeout(() => {
        $.restoreFocus();
        this.bShowFacetAccordionOptions = false;
        this.bFilterAccordionOpen = false;
      });
    }
  }

  showJobDetails() {
    return (
      (this.bJobDetailsShown || this.bJobDetailsNextToSearchResultsShown) &&
      !this.bSignInView &&
      !this.login?.ForgotPass &&
      !this.LoginChangeSecQuestion &&
      !this.bCreateAccount &&
      !this.bPrivacyPages &&
      !this.bMultiplePrivacyPages &&
      !this.bJobDetailsAPIError
    );
  }

  jobDetailsBackClick() {
    const appScope=(window as any).appScope;
    appScope.handlers.jobDetailsBackClick();
    // The AngularJS handler navigates via history.back()/homeView() which changes
    // the URL correctly but never touches Angular state. Reset visibility flags here.
    this.bJobDetailsShown = false;
    this.showJobdetailsPage = false;
    // Partial apply manages its own visibility via its internal bJobDetailsShown flag.
    // Set it directly so the component hides without being destroyed and recreated.
    //if (this.partialApplyRef) this.partialApplyRef.bJobDetailsShown = false;
  }

  homeView() {}

  InitialiseJobdetails(AlertVal: boolean) {
    this.bJobDetailsShown = true;
    this.ShowJobAlert = AlertVal;
    this.bBypassGQLogin = false;
    if (!this.bLoggedIn) this.AnonymousLoginType = '';
  }

  viewHRStatus() {
    (window as any).appScope?.viewHRStatus?.();
    // The AngularJS handler navigates via history.back()/homeView() which changes
    // the URL correctly but never touches Angular state. Reset visibility flags here.
    this.bJobDetailsShown = false;
    this.showJobdetailsPage = false;
    // Partial apply manages its own visibility via its internal bJobDetailsShown flag.
    // Set it directly so the component hides without being destroyed and recreated.
   // if (this.partialApplyRef) this.partialApplyRef.bJobDetailsShown = false;
  }

  SlidePartialApplyQues() {
    this.partialApplyRef?.SlidePartialApplyQues();
  }

  ViewDashBoardData(tab: any, activeSection: any) {}

  isJobHot(job: any): boolean {
    if (!job || !job.Questions) return false;
    return (
      _.map(_.filter(job?.Questions, { QuestionName: 'hotjob' }), 'Value')
        ?.toString()
        ?.toLowerCase() == 'yes'
    );
  }

  jobNextPrevHot(scope: any, param: any) {
    param = param + 'Job';
    return (
      _.map(
        _.filter(scope?.[param]?.Questions, { QuestionName: 'hotjob' }),
        'Value',
      )
        ?.toString()
        ?.toLowerCase() == 'yes'
    );
  }
  toogleJobShare(job: any) {
    if (typeof job?.jobShare == 'undefined') job.jobShare = true;
    else job.jobShare = !job.jobShare;

    if (job.jobShare) $.captureFocus();
    else $.restoreFocus();
    return job;
  }

  initJobShare(job: any) {
    if (job) job.jobShare = false;
    return job;
  }

  scrollToSimilarJobs() {
    window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
    });
    setTimeout(() => {
        document.getElementById('similar-jobs-heading')?.focus();
    }, 500);
  }

  onViewSimilarJobsBtnChange(show: boolean): void {
    this.viewSimilarJobsBtn = show;
    this.cdr.detectChanges();
  }

  onViewRelaventjobsJobsBtnChange(show: boolean): void {
    this.viewRelaventjobsJobsBtn = show;
    this.cdr.detectChanges();
  }

  initReading() {
    if (typeof window !== 'undefined' && window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
  }

  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  }

  handleVolumeOnClick() {}
  handleLabelKeyPressed(event: any) {}

  startReading() {
    if (typeof window === 'undefined' || !window.speechSynthesis) return;

    const isCurrentlySpeaking =
      this.isPlaying || window.speechSynthesis.speaking;
    if (isCurrentlySpeaking) {
      window.speechSynthesis.resume();
      this.isPlaying = true;
      this.dropdownVisible = true;
      return;
    }

    const questions = document.querySelectorAll(
      '.mainDetails .questionClass .question, .mainDetails .questionClass .answer',
    );
    let textToRead = '';
    questions.forEach((question) => {
      question.childNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const el = node as HTMLElement;
          if (
            el.tagName.toLowerCase() === 'ul' ||
            el.tagName.toLowerCase() === 'ol'
          ) {
            el.querySelectorAll('li').forEach((li, index) => {
              let prefix = '';
              const parent = li.parentNode as HTMLElement;
              if (parent.tagName.toLowerCase() === 'ol') {
                const type = parent.getAttribute('type');
                switch (type) {
                  case '1':
                    prefix = index + 1 + '. ';
                    break;
                  case 'a':
                    prefix = String.fromCharCode(97 + index) + '. ';
                    break;
                  case 'A':
                    prefix = String.fromCharCode(65 + index) + '. ';
                    break;
                  case 'i':
                    prefix =
                      this.convertToRoman(index + 1).toLowerCase() + '. ';
                    break;
                  case 'I':
                    prefix = this.convertToRoman(index + 1) + '. ';
                    break;
                  default:
                    prefix = index + 1 + '. ';
                    break;
                }
              } else {
                prefix = '• ';
              }
              textToRead += prefix + li.innerText.trim() + ' ';
            });
          } else {
            textToRead += (el as HTMLElement).innerText.trim() + ' ';
          }
        } else if (node.nodeType === Node.TEXT_NODE) {
          textToRead += node.textContent?.trim() + ' ';
        }
      });
    });

    textToRead = textToRead.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    textToRead = textToRead.replace(/(\S{20,})/g, function (match) {
      return match?.match(/.{1,20}/g)?.join(' ') ?? match;
    });
    if (textToRead.trim() === '') {
      return;
    }
    var speech = new SpeechSynthesisUtterance();
    var localcodestore = this.tgSettings?.['LocaleCode'];
    const allLocalCodes: any = {
      'ar-SA': 'ar-SA',
      'bg-BG': 'bg-BG',
      'tw-TW': 'zh-TW',
      cs: 'cs-CZ',
      'da-dk': 'da-DK',
      de: 'de-DE',
      'el-GR': 'el-GR',
      'en-us': 'en-US',
      'fi-fi': 'fi-FI',
      fr: 'fr',
      'he-IL': 'he-IL',
      hu: 'hu-HU',
      it: 'it-IT',
      ja: 'ja-JP',
      ko: 'ko-KR',
      nl: 'nl-NL',
      'NO-NO': 'no-NO',
      pl: 'pl-PL',
      'pt-br': 'pt-BR',
      'ro-RO': 'ro-RO',
      'ru-RU': 'ru-RU',
      'hr-HR': 'hr-HR',
      sk: 'sk-SK',
      sv: 'sv-SE',
      'th-TH': 'th-TH',
      tr: 'tr-TR',
      'id-ID': 'id-ID',
      'sl-SI': 'sl-SI',
      'lt-LT': 'lt-LT',
      az: 'az-AZ',
      'cy-GB': 'cy-GB',
      'ZH-CN': 'zh-CN',
      'en-gb': 'en-GB',
      'pt-PT': 'pt-PT',
      sr: 'sr-RS',
      es: 'es-ES',
      'fr-CA': 'fr-CA',
      'de-IN': 'de-IN',
      'gv-US': 'gv-US',
      'hu-IN': 'hu-IN',
      'nl-IN': 'nl-NL',
      'hr-IN': 'hr-HR',
      'sk-IN': 'sk-SK',
      'sl-IN': 'sl-SI',
      'GG-GB': 'en-GB',
      'es-IN': 'es-ES',
      'er-US': 'en-US',
    };
    var matchedlocalstring = allLocalCodes[localcodestore] || 'en-US';
    speech.lang = matchedlocalstring;
    var chunkSize = 150;
    var chunks =
      textToRead.match(new RegExp('.{1,' + chunkSize + '}(\\s|$)', 'g')) || [];
    var chunkIndex = this.pausedChunkIndex || 0;
    const speakChunk = () => {
      if (chunkIndex < chunks.length) {
        speech.text = chunks[chunkIndex];
        speech.onend = () => {
          chunkIndex++;
          speakChunk();
        };
        speech.onerror = () => {
          this.isPlaying = false;
        };
        window.speechSynthesis.speak(speech);
      } else {
        this.isPlaying = false;
        this.pausedChunkIndex = 0;
      }
    };

    speakChunk();
    this.isPlaying = true;
  }

  pauseReading() {
    if (typeof window === 'undefined' || !window.speechSynthesis) return;
    if (window.speechSynthesis.speaking && !window.speechSynthesis.paused) {
      window.speechSynthesis.pause();
      this.isPlaying = false;
    } else if (window.speechSynthesis.paused) {
      window.speechSynthesis.resume();
      this.isPlaying = true;
    }
  }

  cancelReading() {
    if (typeof window === 'undefined' || !window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    this.isPlaying = false;
    this.pausedChunkIndex = 0;
  }

  private convertToRoman(num: number): string {
    const roman: any = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1,
    };
    let str = '';
    for (const i in roman) {
      while (num >= roman[i]) {
        str += i;
        num -= roman[i];
      }
    }
    return str;
  }


  public switchSite(switchToSiteId: any, calledFrom: any): void {
    this.showPolicySwitchSite = 'noBroadcast';
    const switchSiteRequest: any = {
      PartnerId: $('#partnerId').val(),
      SwitchToSiteId: switchToSiteId,
      FromSiteId: $('#siteId').val(),
      CookieValue: $('#CookieValue').val(),
    };

    this.jobsidepreviewservice.switchSite(switchSiteRequest).subscribe({
      next: (data: any) => {
        if (data?.Success === true) {
          if (calledFrom === 'savedJobs') {
            this.showPolicySwitchSite = '';
            if (data?.PendingPolicyAcceptance === true) {
              this.showPolicySwitchSite = '&showHomePolicySwitchSite=true';
            }
          } else if (calledFrom === 'fromApply') {
            this.showPolicySwitchSite = '';
            if (data?.PendingPolicyAcceptance === true) {
              this.showPolicySwitchSite = '&showPolicySwitchSite=true';
            }
          } else {
            let showPolicySwitchSite = '';
            if (data?.PendingPolicyAcceptance === true) {
              showPolicySwitchSite = '&showHomePolicySwitchSite=true';
            }
            window.location.href =
              '/TgNewUI/Search/Home/Home?partnerid=' +
              $('#partnerId').val() +
              '&siteid=' +
              switchToSiteId +
              showPolicySwitchSite;
          }
          $('#SIDValue').val(data?.newSID);
        }
      },
      error: (error: any) => {
        console.error('Switch site failed', error);
      },
    });
  }
 

  private showVBTWarningAlert(): boolean {
    if (this.bConfigMode) {
      window.alert(this.dynamicStrings?.VBT_WarningMessage ?? '');
      return true;
    }
    return false;
  }

  private saveToJobCartAjax(partnerId: string, siteId: string, jobsToBeSaved: any[]): void {
    if (!jobsToBeSaved.length) return;
    const rft: string = $('[name="__RequestVerificationToken"]').val();
    const payload = {
      ClientId: partnerId,
      SiteId: siteId,
      JobsToBeSaved: jobsToBeSaved,
      SessionID: $('#CookieValue').val(),
    };
    this.http.post<any>('/TgNewUI/CandidateZone/Ajax/AddJobsToCart', payload, { headers: { RFT: rft } }).subscribe({
      next: (data: any) => {
        const fromJobDetails = this.tgSettings?.['DisplayJobDetailsNextToSearchResults']?.toLowerCase() === 'yes' && !this.mobileScreen
          ? this.bJobDetailsNextToSearchResultsShown
          : this.bJobDetailsShown;

        const maxJobsToSave = 50;
        const isMaxReached = (data.JobsSavedBeforeAddingToCart >= maxJobsToSave) && data.JobsToBeAddedToCart !== 0;
        const isExceeded = !isMaxReached && (data.JobsSavedBeforeAddingToCart + data.JobsToBeAddedToCart) > maxJobsToSave;
        const alreadySaved = data.JobsAlreadyPresentInCart?.length > 0;

        if (fromJobDetails && !isMaxReached && !isExceeded && !alreadySaved) {
          this.bJobSaved = true;
                  this.SaveToCartPrompt(data, null, jobsToBeSaved, fromJobDetails);

        } else {
          // Limit/duplicate cases use ngDialog — delegate to AngularJS
        //  (window as any).appScope?.SaveToCartPrompt?.(data, null, jobsToBeSaved, fromJobDetails);
        this.SaveToCartPrompt(data, null, jobsToBeSaved, fromJobDetails);
        }
      },
      error: (err: any) => console.error('SaveToJobCart failed', err),
    });
  }
   SaveToCartPrompt(data:any, oldScope:any, JobsToBeSaved:any, fromJobDetails:any){
     var bJobsAlreadySaved = false;
     var JobsToBeDeSelected = 0;
     var bJobsSavedExceeded = false;
     var JobsAlreadyPresentInCart = data.JobsAlreadyPresentInCart;
     var JobsAddedToCart = data.JobsAddedToCart;
     var MaximumJobsToSave = 50;
     let bJobsSaved;
     let bSearchSaved;
     var bJobsSavedReachedMaxLimit = (data.JobsSavedBeforeAddingToCart) >= MaximumJobsToSave && data.JobsToBeAddedToCart != 0 ? true : false;
     if (!bJobsSavedReachedMaxLimit)
     {
         bJobsSavedExceeded = (data.JobsSavedBeforeAddingToCart + data.JobsToBeAddedToCart) > MaximumJobsToSave ? true : false;
         if (bJobsSavedExceeded)
         {
             JobsToBeDeSelected = (data.JobsSavedBeforeAddingToCart + data.JobsToBeAddedToCart) - MaximumJobsToSave;
         }
         else
         {
             if (data.JobsAlreadyPresentInCart != null && data.JobsAlreadyPresentInCart.length > 0)
             {
                 bJobsAlreadySaved = true;
             }
             else
             {
                 bJobsAlreadySaved = false;
             }
         }
     }


     if (typeof fromJobDetails != 'undefined' && fromJobDetails && !(bJobsSavedReachedMaxLimit || bJobsSavedExceeded || JobsAlreadyPresentInCart.length > 0))
     {
         this.bJobSaved = true;
         this.sendToFriendInfo.emailSent = false;
        // this.adjustHeaderStickers();
     }
     else if (this.bSearchResults && !fromJobDetails && JobsAlreadyPresentInCart.length == 0 && JobsAddedToCart.length > 0)
     {
        bJobsSaved = true;
        bSearchSaved = false;
        // this.adjustHeaderStickers();
     }
     else
     {
         let message: string;
         if (bJobsSavedReachedMaxLimit) {
           message = this.translate.instant('JobsSavedReachedMaximumLimit', { MaximumJobsToSave });
         } else if (bJobsSavedExceeded) {
           message = this.translate.instant('MaximumJobsMessage', { MaximumJobsToSave, JobsToBeDeSelected });
         } else {
           message = this.translate.instant('JobsAlreadySaved');
         }

         const snackBarRef = this.snackBar.open(message, this.translate.instant('Button_Ok'), {
           duration: 5000,
           panelClass: 'job-cart-snackbar',
         });

         snackBarRef.afterDismissed().subscribe(() => {
           if (!this.bJobDetailsShown && JobsAddedToCart?.length > 0 && !(this.bCandidateZone && (window as any).appScope?.bJobCart)) {
             (window as any).appScope?.adjustHeaderStickers?.();
           }
           $.restoreFocus();
         });
     }
     (window as any).appScope?.CallApply?.();
 }


  public loadJobDetailsByHomeWithPreload(payload: any): void {
    this.jobsidepreviewservice.homeWithPreload(payload).subscribe({
      next: () => {
        const jobDetailsRequest = {
          partnerId: payload.partnerId || payload.partnerid || '',
          siteId: payload.siteId || payload.siteid || '',
          jobid: payload.jobId || payload.jobid || '',
          configMode: typeof $ !== 'undefined' ? ($('#configMode').val() as string) : '',
          jobSiteId: payload.siteId || payload.siteid || '',
          turnOffHttps: false,
        };
        this.jobsidepreviewservice.jobdetails(jobDetailsRequest).subscribe({
          next: (data: any) => {
            this.bindJobDetailsData(data, jobDetailsRequest, true, undefined, null);
          },
          error: (err: any) => {
            console.error('Job details fetch failed in homeWithPreload flow', err);
          }
        });
      },
      error: (err: any) => {
        console.error('HomeWithPreload request failed', err);
      }
    });
  }

  public jobTitle(url:any,jobDetailsRequest:any,launchJobDetailsOnLoad:any, currentElem_id:any,jobs: any){
     this.partnerid= this.jobDetailsInputParams?.jobdetailrequestdata?.partnerId;
     this.siteid= this.jobDetailsInputParams?.jobdetailrequestdata?.siteId;
     this.http.post<any>(url, jobDetailsRequest).subscribe({
        next: (data: any) => {
         this.bindJobDetailsData(data, jobDetailsRequest,launchJobDetailsOnLoad, currentElem_id,jobs);
        },
        error: (err: any) => {
          console.error('JobDetails API call failed', err);
        }
      });
  }
  
  bindJobDetailsData(data: any, jobDetailsRequest: any, launchJobDetailsOnLoad: any, currentElem_id: any,jobs:any) {
    this.jobs =jobs;
    data = data;
    this.showJobdetailsPage=true;
    // Settings load is async; by the time job data arrives the GET has resolved.
    // Refresh here so EnablePartialApplyQuestions and template *ngIf are current.
    const latestSettings = this.tgSettingsService.getCurrentSettings()?.tgSettings;
    if (latestSettings && Object.keys(latestSettings).length > 0) {
      this.tgSettings = latestSettings;
    }
    this.LimitExceededMessage = data?.ServiceResponse?.LimitExceededMessage;
    this.ApplyDifference = data?.ServiceResponse?.ApplyDiff;
    const appScope=(window as any).appScope;
    appScope.ApplyDifference=this.ApplyDifference;
    this.AllowReApply =
      data?.ServiceResponse?.ApplyStatus != null
        ? data?.ServiceResponse?.ApplyStatus?.AllowReApply
        : true;
    this.Applied =
      data?.ServiceResponse?.ApplyStatus != null
        ? data?.ServiceResponse?.ApplyStatus?.Applied
        : false;
    this.jobDetailsFieldsToDisplay = data?.ServiceResponse?.JobFieldsToDisplay;
    this.encryptedBruid = data?.ServiceResponse?.EncryptedBruid;
    this.hashCode = data?.ServiceResponse?.HashCode;
    // this.jobDetailFields = data?.ServiceResponse?.Jobdetails;
    this.jobDetailFields = data?.ServiceResponse?.Jobdetails;
    appScope.jobDetailFields = this.jobDetailFields;
   
    let jobSiteId: any = jobDetailsRequest?.jobSiteId || data?.ServiceResponse?.Jobdetails?.JobSiteId;

    if (this.jobDetailFields != null) {
      this.isHotJob =
        _.map(
          _.filter(data?.ServiceResponse?.Jobdetails?.JobDetailQuestions, {
            VerityZone: 'hotjob',
          }),
          'AnswerValue',
        )
          ?.toString()
          ?.toLowerCase() == 'yes';
      this.enableJobDetailsSendToFriend =
        this.tgSettings?.['SendToFriend']?.toLowerCase() == 'yes' ? true : false;
      this.enablePostToMySocialNetwork =
        this.tgSettings?.['EnablePostToMySocialNetworkLink']?.toLowerCase() ==
          'yes' && this.tgSettings?.SocialMedia != ''
          ? true
          : false;
      let jobId = _.map(
        _.filter(data?.ServiceResponse?.Jobdetails?.JobDetailQuestions, {
          VerityZone: 'reqid',
        }),
        'AnswerValue',
      )?.toString();
      this.jobDetailsUrlForSocialMedia =
        $('#pageURL').val() +
        '/TGNewUI/Search/Home/HomeWithPreLoad?partnerid=' +
        $('#partnerId').val() +
        '&siteid=' +
        jobSiteId +
        '&jobid=' +
        jobId +
        '&PageType=jobdetails';

      this.jobDetailsButtonText =
        this.tgSettings?.['JobDetailsSendToFriendButtonText'] &&
        this.tgSettings?.['JobDetailsSendToFriendButtonText'].length > 0
          ? this.tgSettings?.['JobDetailsSendToFriendButtonText']
          : this.dynamicStrings?.JobDetails_SendToFriend;

      if (!launchJobDetailsOnLoad)
        this.bJDScroll = this.tgSettings?.['JDScrollEnabled'];
      else this.bJDScroll = false;
      this.hTrackJDScrl = -1;
      this.jobDetailFields.slide = true;

      this.SkillsFields = data?.ServiceResponse?.SkillsFields;
      this.ShowSimilarJobs = data?.ServiceResponse?.ShowSimilarJobs;
    }

    if (this.bJDScroll && this.jobs != null && this.jobDetailFields != null) {
      var oneJobID = '';
      var currentJobIndex = 0;
      if (this.jobs?.length == 1)
        oneJobID = _.map(
          _.filter(this.jobs?.[0]?.Questions, { QuestionName: 'reqid' }),
          'Value',
        )?.toString();

      var currentJobID = _.map(
        _.filter(this.jobDetailFields?.JobDetailQuestions, {
          VerityZone: 'reqid',
        }),
        'AnswerValue',
      )?.toString();
      if (oneJobID != '' && oneJobID != currentJobID) {
        this.bJDScroll = false;
      } else {
        currentJobIndex = _.findIndex(this.jobs, (job: any) => {
          return (
            _.map(
              _.filter(job?.Questions, { QuestionName: 'reqid' }),
              'Value',
            )?.toString() == currentJobID
          );
        });
        let nextJobIndex = Number(currentJobIndex) + 1;
        let prevJobIndex = Number(currentJobIndex) - 1;
        if (typeof this.jobs?.[prevJobIndex] != 'undefined') {
          this.prevJob = { Questions: this.jobs?.[prevJobIndex]?.Questions };
          this.prevJob.isSocialReferralJobRestricted =
            this.jobs?.[prevJobIndex]?.isSocialReferralJobRestricted;
        } else this.prevJob = '';
        if (typeof this.jobs?.[nextJobIndex] != 'undefined') {
          this.nextJob = { Questions: this.jobs?.[nextJobIndex]?.Questions };
          this.nextJob.isSocialReferralJobRestricted =
            this.jobs?.[nextJobIndex]?.isSocialReferralJobRestricted;
        } else this.nextJob = '';
      }
      setTimeout(() => {
        this.alignCards('accessoryJobDetails', 'jdCard');
      }, 500);
    }

    this.navigationParams = {
      prevJob: this.prevJob,
      nextJob: this.nextJob,
      bJDScroll: this.bJDScroll,
      enableSocialReferral: this.enableSocialReferral,
      jobDetailFields: this.jobDetailFields,
      JobFieldsToDisplay: this.jobDetailsFieldsToDisplay
    };

    this.solarErrorOccurred = data?.ServiceResponse?.SolarErrorOccurred;
    this.searchResultsURL = '';
    if (this.tgSettings?.['DisplayJobDetailsNextToSearchResults'] != undefined && this.tgSettings?.['DisplayJobDetailsNextToSearchResults']?.toLowerCase() == 'yes' && !this.mobileScreen) {
      if (this.workFlow == 'welcome') {
        this.bInitialLoad = true;
        this.bSidebarVisible = false;
        $('.widgetSidebar').animate({ width: '0%', opacity: '0' });
        $('.widgetSidebar').hide();
      } else {
        this.bSidebarVisible = true;
        this.bInitialLoad = false;
      }
      this.bJobDetailsShown = false;
      this.bJobDetailsNextToSearchResultsShown = true;
      this.bSearchResults = true;
      this.bNewSearchResultPage = true;
      if (this.tgChatBot && this.tgChatBot.chatbotjobclick === true) {
        this.bSidebarVisible = false;
        this.bInitialLoad = false;
        this.bJobDetailsShown = true;
        this.tgChatBot.chatbotjobclick = false;
      }
    } else {
      this.bSidebarVisible = false;
      this.bInitialLoad = false;
      this.bJobDetailsShown = true;
    }
    let jobId = _.map(
      _.filter(data?.ServiceResponse?.Jobdetails?.JobDetailQuestions, {
        VerityZone: 'reqid',
      }),
      'AnswerValue',
    )?.toString();
    this.jobSiteInfo = jobId + '_' + jobSiteId;
    this.bJobSaved = false;
    if (this.jobDetailFields != null) {
      this.JobDetailQuestionsSocialShare =
        data?.ServiceResponse?.Jobdetails?.JobDetailQuestions;
    }
    $('#title').nextUntil('meta[name=lcGlobalBaseUrl]', 'meta').remove();
    // setTimeout(() => {
    //   (this as any).$scope.$apply();
    // }, 0);

    var metaTag = this.tgSettings?.['JobDetailsMetaTagText'] || '';
    metaTag = String(metaTag).replace(
      /#ClientName#/g,
      data?.ServiceResponse?.partnername,
    );
    var stdJobDescText =
      'A job opportunity at ' + data?.ServiceResponse?.partnername;
    var jobdesc: any = '';
    var jobtitl: any = '';
    if (data?.ServiceResponse?.Jobdetails != null) {
      jobdesc = _.map(
        _.filter(data?.ServiceResponse?.Jobdetails?.JobDetailQuestions, {
          VerityZone: this.jobDetailsFieldsToDisplay?.Summary,
        }),
        'AnswerValue',
      )?.toString();
      if (typeof jobdesc == 'undefined' || jobdesc == '') {
        jobdesc = _.map(
          _.filter(data?.ServiceResponse?.Jobdetails?.JobDetailQuestions, {
            VerityZone: 'jobdescription',
          }),
          'AnswerValue',
        )?.toString();
      }
      jobdesc = String(jobdesc || '')
        .replace(/<(.|\n)*?>/g, '')
        .replace('"', '&quot;');
      if (jobdesc?.length > 50) jobdesc = jobdesc?.substring(0, 50);
      jobtitl = _.map(
        _.filter(data?.ServiceResponse?.Jobdetails?.JobDetailQuestions, {
          VerityZone: this.jobDetailsFieldsToDisplay?.JobTitle,
        }),
        'AnswerValue',
      )?.toString();
      if (typeof jobtitl == 'undefined' || jobtitl == '') {
        jobtitl = data?.ServiceResponse?.Jobdetails?.Title?.toString();
      }
      jobtitl = String(jobtitl || '')
        .replace(/<(.|\n)*?>/g, '')
        .replace('"', '&quot;');
      if (jobtitl?.length > 50) jobtitl = jobtitl?.substring(0, 50);
    }

    if (metaTag) {
      metaTag =
        jobdesc == ''
          ? metaTag.replace('#JobDescription#', stdJobDescText)
          : metaTag.replace('#JobDescription#', jobdesc);
      $('#title').after(metaTag.replace('#JobTitle#', jobtitl));
    }

    if (
      data?.ServiceResponse?.Jobdetails != null &&
      data?.ServiceResponse?.googlejobsMappingfielddataJson != null
    ) {
      $('#title').after(data?.ServiceResponse?.googlejobsMappingfielddataJson);
    }

    if (launchJobDetailsOnLoad) {
      setTimeout(() => {
        (this as any).bInitialPageLoad = false;
        appScope.bInitialPageLoad = false;
        $('.MainContent').show();
        document.title =
          $('h1.jobtitleInJobDetails:visible').text() +
          ' | ' +
          data?.ServiceResponse?.partnername;
      }, 10);
    }

    setTimeout(() => {
      this.webTrackerService.loadwebtrackerscript(
        '/TGNewUI/JobDetails',
        this.customScriptRendering?.Search,
        data?.ServiceResponse?.Jobdetails,
      );
    }, 0);


    setTimeout(() => {
      const appScope = (window as any).appScope;
      //appScope.bJobDetailsShown = true;
      if(appScope){
        // appScope.setHash(this.bFromHistory, arguments, this);
        // appScope.workFlow = 'jobDetails';
        // appScope.utils.updateHistory(appScope.$location.hash());
      }
      if ( this.tgSettings?.['DisplayJobDetailsNextToSearchResults'] != undefined && String( this.tgSettings?.['DisplayJobDetailsNextToSearchResults'],).toLowerCase() == 'yes' && !this.mobileScreen ) {
        // #JobDetailsInAngular is the container injected by search.js only in SearchResultsEnhanced.cshtml.
        // jobdetails.cshtml uses a different full-page layout and must not enter this block.
        const $jdContainer = $('#JobDetailsInAngular');
        if ($jdContainer.length > 0 && $jdContainer.is(':hidden')) {
          var $sidebar = $('.listContainer.sidebar');
          var openDetailsFn = () => {
            if ($('#mainMapContainer').is(':visible')) {
              $('#mainMapContainer').animate({ width: '40%' });
              $('.newSearchResult').addClass('map-split-view');
            } else {
              $('#mainJobListContainer').animate({ width: '40%' });
            }
            $jdContainer.animate({
              width: '60%',
              opacity: '1',
            });
            $jdContainer.show();
            $sidebar.hide();
          };

          if ($sidebar.length > 0) {
            $sidebar.animate({ width: '0%', opacity: '0' }, 100, openDetailsFn);
          } else {
            openDetailsFn();
          }

          $('.searchResultLayout').hide();
          $(
            '.newSearchResult #mainJobListContainer.mainListContainer.listContainer.cardLayout ul.jobList',
          ).addClass('jobDetailsVisible');
          $('.newSearchResult #mainMapContainer.mainListContainer').addClass(
            'jobDetailsVisible',
          );
          setTimeout(() => {
            $('.jobtitleInJobDetails').trigger('focus');
          }, 500);
        }

        
        if ((this as any).headerBackgroundColor == undefined && this.response) {
          var brandingConfig = JSON.parse(
            (this.response as any)?.BrandingConfiguration || '{}',
          );
          (this as any).headerBackgroundColor = '';
          if (
            brandingConfig?.brandingSettings
              ?.Responsive_HeaderBackgroundColor == ''
          ) {
            (this as any).headerBackgroundColor =
              $('.pageHeader').css('background-color');
          } else {
            (this as any).headerBackgroundColor =
              brandingConfig?.brandingSettings?.Responsive_HeaderBackgroundColor;
          }
        }
        if ((this as any).prevElem_id != undefined) {
          $('#' + (this as any).prevElem_id)
            .closest('li')
            .css('border', '');
        }
        $('#' + currentElem_id)
          .closest('li')
          .css('border', `2px solid ${(this as any).headerBackgroundColor}`);
        (this as any).prevElem_id = currentElem_id;
      }
    }, 10);

    setTimeout(() => {
      if (this.tgSettings?.['DisplaySimilarJobsonJobDetailView']?.toLowerCase() === 'yes' ||
          this.tgSettings?.SuggestMatchingRoles?.toLowerCase() === 'yes') {
        this.jobtojobListInputParams = {
          partnerId: this.partnerid,
          siteId: this.siteid,
          ReqId: jobId,
          cookieValue: $('#CookieValue').val(),
          showjobdetails: true,
          pagetype: 'jobdetail',
          tgsetting: this.tgSettings,
          widgetType: (this.tgSettings?.SuggestMatchingRoles?.toLowerCase() === 'yes' && this.bLoggedIn) ? 'profilematch' : 'similarjobs',
          Bruid : appScope.Abc
        };
      }
      if (this.tgSettings?.SuggestMatchingRoles?.toLowerCase() === 'yes'
          && this.bLoggedIn && !this.Applied) {
          this.resumeConsentWorkflowService.start(Number(jobId), 'jobDetail').then(result => {
              if (result === ResumeWorkflowResult.Completed) {
                  this.launchRecommendedJobsWidget = true;
              }
          });
      }
      if (String(this.tgSettings?.['EnablePartialApplyQuestions'])?.toLowerCase() == 'yes' && data?.ServiceResponse?.Jobdetails != null) {
        let gqid = data?.ServiceResponse?.Jobdetails?.GQId;
        let localeid = data?.ServiceResponse?.Jobdetails?.localeId;
        //(this as any).getPartialApplyQuestions(jobDetailsRequest.jobid, gqid, localeid);
        this.PartialApplyRequestInput = {
          gqid: gqid,
          localeid: localeid,
          jobid: jobDetailsRequest.jobid,
          showjobdetails:this.showJobDetails(),
          bLoggedIn:this.bLoggedIn,
          Applied:this.Applied,
          jobDetailFields:this.jobDetailFields,
          solarErrorOccurred:this.solarErrorOccurred,
          EnablePartialApplyQuestions:this.tgSettings?.['EnablePartialApplyQuestions'],
          bJobDetailsShown: this.bJobDetailsShown,
          partnerId: this.partnerid,
          siteId: this.siteid,
          showjobdetailsnexttosearchresults: this.bJobDetailsNextToSearchResultsShown
        };
      }
    }, 50);
  }

  handleJobNavigation(event: { job: any; direction: string }): void {
      setTimeout(() => {
          this.jobNextPrevAjax(event.job, event.direction);
          setTimeout(() => {
              $('.jobtitleInJobDetails').trigger('focus');
              setTimeout(() => {
                  this.alignCards('accessoryJobDetails', 'jdCard');
              }, 500);
          }, 500);
      }, 100);
  }

  jobNextPrevAjax(job: any, upcoming: any): void {
   const appScope = (window as any).appScope;
      if (this.jobDetailFields != null) {
          this.jobDetailFields.JobDetailQuestions = [];
      }

      if (upcoming === 'next') {
          this.hTrackJDScrl++;
      } else {
          this.hTrackJDScrl--;
      }

      const jobId = job.Questions.find((q: any) => q.QuestionName === 'reqid')?.Value ?? '';
      const jobSiteId = job.Questions.find((q: any) => q.QuestionName === 'siteid')?.Value ?? '';
      const url = '/TgNewUI/Search/Ajax/JobDetails';

      const jobDetailsRequest = {
          partnerId: this.partnerid,
          siteId: this.siteid,
          jobid: jobId,
          configMode: $('#configMode').val(),
          jobSiteId: jobSiteId,
          turnOffHttps: $.queryParams()?.sec === '1'
      };

      this.jobDetailsJobShown = `${jobDetailsRequest.jobid}_${jobDetailsRequest.jobSiteId}`;
      this.ShowSimilarJobs = false;

      this.http.post(url, jobDetailsRequest).subscribe({
          next: (data: any) => {
      this.LimitExceededMessage = data.ServiceResponse.LimitExceededMessage;
      this.ApplyDifference = data.ServiceResponse.ApplyDiff;
      this.AllowReApply = data.ServiceResponse.ApplyStatus != null ? data.ServiceResponse.ApplyStatus.AllowReApply : true;
      this.Applied = data.ServiceResponse.ApplyStatus != null ? data.ServiceResponse.ApplyStatus.Applied : false;
      this.jobDetailsFieldsToDisplay = data.ServiceResponse.JobFieldsToDisplay;
      this.encryptedBruid = data.ServiceResponse.EncryptedBruid;
      this.hashCode = data.ServiceResponse.HashCode;
      this.jobDetailFields = data.ServiceResponse.Jobdetails;

      if (this.jobDetailFields != null) {
          this.isHotJob = _.map(_.filter(data.ServiceResponse.Jobdetails.JobDetailQuestions, { VerityZone: 'hotjob' }), 'AnswerValue').toString().toLowerCase() === 'yes';
          this.enableJobDetailsSendToFriend = this.tgSettings?.['SendToFriend']?.toLowerCase() === 'yes';
          this.enablePostToMySocialNetwork = this.tgSettings?.['EnablePostToMySocialNetworkLink']?.toLowerCase() === 'yes' && this.tgSettings?.['SocialMedia'] !== '';
          const currentJobId = _.map(_.filter(data.ServiceResponse.Jobdetails.JobDetailQuestions, { VerityZone: 'reqid' }), 'AnswerValue').toString();
          this.jobDetailsUrlForSocialMedia = $('#pageURL').val() + '/TGNewUI/Search/Home/HomeWithPreLoad?partnerid=' + $('#partnerId').val() + '&siteid=' + jobSiteId + '&jobid=' + currentJobId + '&PageType=jobdetails';
          this.jobDetailsButtonText = this.tgSettings?.['JobDetailsSendToFriendButtonText'] !== '' ? this.tgSettings?.['JobDetailsSendToFriendButtonText'] : this.dynamicStrings?.JobDetails_SendToFriend;
          this.jobDetailFields.slide = true;
          this.SkillsFields = data.ServiceResponse.SkillsFields;
          this.ShowSimilarJobs = data.ServiceResponse.ShowSimilarJobs;
      }

      this.solarErrorOccurred = data.ServiceResponse.SolarErrorOccurred;
      this.searchResultsURL = '';
      this.bSidebarVisible = false;
      this.bInitialLoad = false;
      this.jobSiteInfo = `${jobId}_${jobSiteId}`;
      this.bJobSaved = false;

      if (this.jobDetailFields != null) {
          this.JobDetailQuestionsSocialShare = data.ServiceResponse.Jobdetails.JobDetailQuestions;
      }

      const currentJobID = _.map(_.filter(data.ServiceResponse.Jobdetails.JobDetailQuestions, { VerityZone: 'reqid' }), 'AnswerValue').toString();
      const currentJobIndex = _.findIndex(this.jobs, (jobItem: any) => _.map(_.filter(jobItem.Questions, { QuestionName: 'reqid' }), 'Value').toString() === currentJobID);

      const nextJobIndex = currentJobIndex + 1;
      const prevJobIndex = currentJobIndex - 1;

      if (this.jobs?.[prevJobIndex]) {
          this.prevJob = { Questions: this.jobs[prevJobIndex].Questions };
          this.prevJob.isSocialReferralJobRestricted = this.jobs[prevJobIndex].isSocialReferralJobRestricted;
      } else {
          this.prevJob = '';
      }

      if (this.jobs?.[nextJobIndex]) {
          this.nextJob = { Questions: this.jobs[nextJobIndex].Questions };
          this.nextJob.isSocialReferralJobRestricted = this.jobs[nextJobIndex].isSocialReferralJobRestricted;
      } else {
          this.nextJob = '';
      }

      this.navigationParams = {
          prevJob: this.prevJob,
          nextJob: this.nextJob,
          bJDScroll: this.bJDScroll,
          enableSocialReferral: this.enableSocialReferral,
          jobDetailFields: this.jobDetailFields,
          JobFieldsToDisplay: this.jobDetailsFieldsToDisplay
      };
      this.bJobDetailsShown = true;

      if (this.tgSettings?.['DisplaySimilarJobsonJobDetailView']?.toLowerCase() === 'yes' ||
          this.tgSettings?.SuggestMatchingRoles?.toLowerCase() === 'yes') {
        this.jobtojobListInputParams = {
          partnerId: this.partnerid,
          siteId: this.siteid,
          ReqId: jobId,
          cookieValue: $('#CookieValue').val(),
          showjobdetails: true,
          pagetype: 'jobdetail',
          tgsetting: this.tgSettings,
          widgetType: (this.tgSettings?.SuggestMatchingRoles?.toLowerCase() === 'yes' && this.bLoggedIn) ? 'profilematch' : 'similarjobs',
          Bruid : appScope.Abc
        };
      }

      setTimeout(() => {
          if (String(this.tgSettings?.['EnablePartialApplyQuestions'])?.toLowerCase() == 'yes' && data?.ServiceResponse?.Jobdetails != null) {
        let gqid = data?.ServiceResponse?.Jobdetails?.GQId;
        let localeid = data?.ServiceResponse?.Jobdetails?.localeId;
        //(this as any).getPartialApplyQuestions(jobDetailsRequest.jobid, gqid, localeid);
        this.PartialApplyRequestInput = {
          gqid: gqid,
          localeid: localeid,
          jobid: jobDetailsRequest.jobid,
          showjobdetails:this.showJobDetails(),
          bLoggedIn:this.bLoggedIn,
          Applied:this.Applied,
          jobDetailFields:this.jobDetailFields,
          solarErrorOccurred:this.solarErrorOccurred,
          EnablePartialApplyQuestions:this.tgSettings?.['EnablePartialApplyQuestions'],
          bJobDetailsShown: this.bJobDetailsShown,
          partnerId: this.partnerid,
          siteId: this.siteid
        };
      }
          this.webTrackerService.loadwebtrackerscript('/TGNewUI/JobDetails', this.customScriptRendering?.Search, data?.ServiceResponse?.Jobdetails);
        //  appScope.setHash(appScope.bFromHistory, arguments, this);
          // appScope.$root.workFlow = "jobDetails";
          // appScope.utils.updateHistory(appScope.$location.hash());
      }, 10);
          },
          error: (error: any) => {
              console.error('Failed with status:', error.status);
  }
      });
  }
  alignCards(container: any, elementClass: any) {
    var isApplicationsContainer = false;
    if (container == 'ApplicationsContainer') {
      isApplicationsContainer = true;
      container = 'CollapsedUnfinishedApplications';
    }
    $('.' + container + ' .' + elementClass)
      .css('height', 'auto')
      .find('.cardFooter')
      .removeClass('cardFooterPosition');
   
    if (isApplicationsContainer) {
      this.alignCards('CollapsedAppliedApplications', 'jobCard');
    }
  }
  openSendToFriend(CalledFrom: any, jobs: any): void {
const appScope = (window as any).appScope;
    var jobTitles: any = [];
    var moreJobTitles: any = [];
    var nameString = "", emailID = "";
    const sendToFriendCalledFrom = CalledFrom;
    appScope.sendToFriendCalledFrom = sendToFriendCalledFrom;
    if (sendToFriendCalledFrom == "1")
    {
        $.each(jobs, function (key:any, job:any)
        {
            var obj = $.grep(job.Questions, function (e:any) { return e.ClassName == "jobtitle" });
            var info :any = {};
            info.ClassName = "jobtitleInJobDetails";
            info.AnswerValue = obj[0].Value
            if (key < 3)
            {
                jobTitles.push(info);
            }
            else
            {
                moreJobTitles.push(info)
            }
        }
        )
    }
    else
    {
        jobTitles = $.grep(jobs.JobDetailQuestions, function (e:any) { return e.ClassName == "jobtitleInJobDetails" });
    }
    //Multiple Flows are effecting the fillup of updated contact e-mail Adress of cand in send to friend input field
    //Hence making an ajax call for getting the latest profile dets via ajax call.
    if (this.bLoggedIn)
    {
        var profiledetailsRequest = {
            ClientId: $("#partnerId").val(),
            SiteId: $("#siteId").val(),
            SessionID: $("#CookieValue").val(),
            ResponsiveCandidateZone: this.bresponsiveCandidateZone
        };
        $.ajax({
            type: "POST",
            url: "/TgNewUI/Search/Ajax/Getprofiledetails",
            data: profiledetailsRequest,
            success: (data:any) =>
            {
              var ProfileDetails:any={};
                if (ProfileDetails == null || (typeof ProfileDetails == "undefined"))
                {
                    ProfileDetails = {};
                }
                ProfileDetails.FirstName = data.BasicProfileDetails.FirstName;
                ProfileDetails.LastName = data.BasicProfileDetails.LastName;
                ProfileDetails.email = emailID = data.BasicProfileDetails.email;
                nameString = ProfileDetails ? (ProfileDetails.FirstName ? ProfileDetails.FirstName : "") + (ProfileDetails.LastName ? " " + ProfileDetails.LastName : "") : "";
                appScope.openSendToFriendDialog(nameString, jobTitles, moreJobTitles, emailID);
            }
        });
    }
    else
    {
      appScope.openSendToFriendDialog(nameString, jobTitles, moreJobTitles, emailID);
    }
}

closeJobDetails(): void {
  
    const appScope = (window as any).appScope;
    appScope.handlers.closeJobDetails();
  }
  changeFocusOnJobDetailsPage(page: string){
    const appScope = (window as any).appScope;
    appScope.handlers.changeFocusOnJobDetailsPage(page);
  }
 
}
